export const checkIfTokenIsExpired = (exp: number): boolean => {
  const currentDate = new Date().getTime() / 1000;
  return exp - currentDate < 0;
};
